import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SAVE_SERVICE } from '@core/saves/saves.interface';
import { ACTIVATION_SERVICE } from '@features/auth/activation.service.interface';
import { HomeProfileService } from '../home-profile.service';
import { PortalButtonDirective } from '../portal-button/portal-button.directive';
import { PortalInputComponent } from '../portal-input/portal-input.component';
import { PortalPanelComponent } from '../portal-panel/portal-panel.component';

@Component({
  selector: 'app-portal-login',
  imports: [PortalPanelComponent, PortalInputComponent, FormsModule, ReactiveFormsModule, PortalButtonDirective],
  templateUrl: './portal-login.component.html',
  styleUrl: './portal-login.component.css',
})
export class PortalLoginComponent {
  saveService = inject(SAVE_SERVICE);
  activationService = inject(ACTIVATION_SERVICE);
  homeProfileService = inject(HomeProfileService);

  protected form = new FormGroup({
    name: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    playerCode: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
  });

  router = inject(Router);
  showPlayerCodeInvalid = signal(false);

  navigateToSelectDeviceType() {
    this.router.navigate(['/selectDeviceType']);
  }

  onSubmit() {
    if (this.form.valid) {
      // Handle form submission
      console.log('Form submitted:', this.form.value);
      const playerCode = this.form.value.playerCode;
      const name = this.form.value.name;
      if (playerCode && name) {
        this.saveService
          .login(playerCode)
          .then(() => {
            // Login successful
            console.log('Login successful');
            //activate as home device
            this.activationService.setActivationData({
              deviceName: this.form.value.name || 'Home Device',
              deviceIdentifier: crypto.randomUUID(),
              instituteName: '',
              token: '', // Token should be set based on your authentication logic
              isHomeDevice: true,
            });
            this.saveService.logout();
            this.homeProfileService.addHomeProfile({
              name: name,
              playerCode: playerCode,
            });
            this.router.navigate(['/select-home-profile']);
          })
          .catch((error) => {
            console.error('Login failed boi:', error);
            this.showPlayerCodeInvalid.set(true);
            return;
          });
      }
    }
  }
}
